export default __webpack_public_path__ + "static/media/chef-icon.866e076b.svg";